import { apiClient } from "lib/apiClient";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

interface IOpenChatKitSessionParams {
  code: assistantPageCodeEnum;
  propertyId?: string;
}

export const openChatKitSession = async ({
  code,
  propertyId,
}: IOpenChatKitSessionParams): Promise<string> => {
  const response = await apiClient.post(
    `/assistant/pages/${code}/chatkit/session/open`,
    { propertyId }
  );
  return response.data.clientSecret;
};
